<template>
  <Doughnut
    :options="computedChartOptions"
    :data="chartData"
    :chart-id="chartId"
    :dataset-id-key="datasetIdKey"
    :plugins="plugins"
    :width="width"
    :height="height"
    data-test-name="donut-chart"
    data-test-variant=""
    data-test-state=""
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { Doughnut } from 'vue-chartjs'
import * as ChartJS from 'chart.js'
import { cloneDeep, merge } from 'lodash-unified'
import { getChartDefaultOptions } from './utils'
import type { PropType } from 'vue'
import type { ChartData, ChartOptions, Plugin } from 'chart.js'

const { ArcElement, CategoryScale, Chart, Legend, Title, Tooltip } = ChartJS
Chart.register(Title, Tooltip, Legend, ArcElement, CategoryScale)

defineOptions({ name: 'BDonutChart' })

const props = defineProps({
  chartId: {
    type: String,
    default: 'donut-chart',
  },
  datasetIdKey: {
    type: String,
    default: 'label',
  },
  width: {
    type: Number,
    default: 240,
  },
  height: {
    type: Number,
    default: 240,
  },
  plugins: {
    type: Array as PropType<Plugin<'doughnut'>[]>,
    default: () => [],
  },
  chartData: {
    type: Object as PropType<ChartData<'doughnut', number[], unknown>>,
    default: () => ({ datasets: [] }),
  },
  chartOptions: {
    type: Object as PropType<ChartOptions<'doughnut'>>,
    default: () => ({ responsive: true, maintainAspectRatio: true }),
  },
})

const defaultOptions = cloneDeep(
  getChartDefaultOptions('donut')
) as ChartOptions<'doughnut'>

const computedChartOptions = computed(() =>
  merge(defaultOptions, props.chartOptions)
)
</script>
